export const resetButtonStyle = {
    colorScheme: 'black',
    variant: 'link',
    size: 'sm'
};